import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_RECEIPT_JUNIOR_PILOT_STORE_NAME, GetReceiptJuniorPilotState } from './get-receipt-junior-pilot.state';

/** Select GetReceiptJuniorPilot State */
export const selectGetReceiptJuniorPilotState = createFeatureSelector<GetReceiptJuniorPilotState>(
  GET_RECEIPT_JUNIOR_PILOT_STORE_NAME
);

/** Select GetReceiptJuniorPilot isPending status */
export const selectGetReceiptJuniorPilotIsPendingStatus = createSelector(
  selectGetReceiptJuniorPilotState,
  (state) => !!state.isPending
);

/** Select GetReceiptJuniorPilot isFailure status */
export const selectGetReceiptJuniorPilotIsFailureStatus = createSelector(
  selectGetReceiptJuniorPilotState,
  (state) => !!state.isFailure
);
